var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28044",
    "data-name": "Group 28044",
    transform: "translate(-1149.5 -429.921)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1727",
    "data-name": "Ellipse 1727",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1149.5 429.921)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_calendar",
    "data-name": "vuesax/bold/calendar",
    transform: "translate(661.5 245.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(492 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H16V16H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.131,1.545V.5a.5.5,0,1,0-1,0v1H3.8V.5a.5.5,0,1,0-1,0V1.545A2.835,2.835,0,0,0,0,4.386a.335.335,0,0,0,.333.354H11.6a.331.331,0,0,0,.333-.354A2.835,2.835,0,0,0,9.131,1.545Z",
    transform: "translate(2.032 0.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.322,0H.666A.669.669,0,0,0,0,.669V4.788A2.993,2.993,0,0,0,3.33,8.131H8.658a2.993,2.993,0,0,0,3.33-3.343V.669A.669.669,0,0,0,11.322,0ZM4.136,5.6a1.05,1.05,0,0,1-.1.08.5.5,0,0,1-.12.06.422.422,0,0,1-.12.04.9.9,0,0,1-.133.013.661.661,0,0,1-.253-.053.687.687,0,0,1-.22-.14.68.68,0,0,1,0-.95.687.687,0,0,1,.22-.14.634.634,0,0,1,.386-.04.422.422,0,0,1,.12.04.5.5,0,0,1,.12.06l.1.08a.68.68,0,0,1,0,.95Zm0-2.34a.673.673,0,0,1-.946,0,.68.68,0,0,1,0-.95.663.663,0,0,1,.726-.14.621.621,0,0,1,.22.14.68.68,0,0,1,0,.95ZM6.467,5.6a.67.67,0,0,1-.946-.95.7.7,0,0,1,.946,0,.68.68,0,0,1,0,.95Zm0-2.34-.1.08a.5.5,0,0,1-.12.06.422.422,0,0,1-.12.04.9.9,0,0,1-.133.013.661.661,0,0,1-.666-.669.7.7,0,0,1,.193-.475.621.621,0,0,1,.22-.14.663.663,0,0,1,.726.14.68.68,0,0,1,0,.95ZM8.8,5.6a.67.67,0,0,1-.946-.95.7.7,0,0,1,.946,0,.68.68,0,0,1,0,.95Zm0-2.34-.1.08a.5.5,0,0,1-.12.06.422.422,0,0,1-.12.04,1,1,0,0,1-.133.013.661.661,0,0,1-.666-.669.7.7,0,0,1,.193-.475.687.687,0,0,1,.22-.14.634.634,0,0,1,.386-.04.422.422,0,0,1,.12.04.5.5,0,0,1,.12.06l.1.08a.68.68,0,0,1,0,.95Z",
    transform: "translate(2.006 6.532)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCircle);
export default __webpack_public_path__ + "static/media/calendar-circle.55b70c4cd737c6f4bce485869a7be56d.svg";
export { ForwardRef as ReactComponent };